import { ChangeDetectorRef, Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FikoYTService } from '../../../../../../fikoyt.service';
import { FikoThreeJsComponent } from '../../fiko-three-js.component';
import { DraftAngleComponent } from './draft-angle/draft-angle.component';
import { UndercutComponent } from './undercut/undercut.component';
import { WallThicknessComponent } from './wall-thickness/wall-thickness.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'fikoyt-fiko-analiz',
  templateUrl: './fiko-analiz.component.html',
  styleUrls: ['./fiko-analiz.component.scss'],
  imports: [CommonModule, FormsModule, DraftAngleComponent, UndercutComponent, WallThicknessComponent],
  standalone: true
})
export class FikoAnalizComponent implements OnDestroy {
  @ViewChild('FikoYTDraftAngle') FikoYTDraftAngle: DraftAngleComponent;
  @ViewChild('FikoYTUndercut') FikoYTUndercut: UndercutComponent;
  @ViewChild('FikoYTWallThickness') FikoYTWallThickness: WallThicknessComponent;

  id_dialog = "dialogFikoAnaliz" + this.FikoYT.fikoIdUret();
  subsList: Subscription[] = [];
  haritaOlaylar: Map<string, any> = new Map();
  private dialogCloseSub: Subscription | null = null;
  // Modal initialization kontrolü - modal sadece bir kez initialize edilir
  private modalBaslatildi = false;

  private _analizTipi: "DraftAngle" | "Undercut" | "DuvarKalinlik" | null = "DraftAngle";
  public get analizTipi(): "DraftAngle" | "Undercut" | "DuvarKalinlik" | any {
    return this._analizTipi;
  }
  public set analizTipi(v: "DraftAngle" | "Undercut" | "DuvarKalinlik" | any) {
    if (this.FikoYTDraftAngle) {
      this.FikoYTDraftAngle.bitir();
    }

    if (this.FikoYTUndercut) {
      this.FikoYTUndercut.bitir();
    }

    if (this.FikoYTWallThickness) {
      this.FikoYTWallThickness.bitir();
    }

    if (v == "DraftAngle") {
      this.FikoYTDraftAngle.baslat(this.anaGosterim);
    }
    if (v == "Undercut") {
      this.FikoYTUndercut.baslat(this.anaGosterim);
    }
    if (v == "DuvarKalinlik") {
      this.FikoYTWallThickness.baslat(this.anaGosterim);
    }
    this._analizTipi = v;
  }

  @Input() anaGosterim: FikoThreeJsComponent;

  private _pencere: any;

  @Input()
  public get pencere(): any {
    return this._pencere;
  }

  public set pencere(v: any) {
    this._pencere = v?.instance || v;

    if (this.dialogCloseSub) {
      this.dialogCloseSub.unsubscribe();
      this.dialogCloseSub = null;
    }
 
    if (this._pencere && this._pencere.onDialogClose) {
      this.dialogCloseSub = this._pencere.onDialogClose.subscribe(() => {
        setTimeout(() => {
          this.temizle();
        }, 0);
      });
    }
  }

  @Input() ayarlar: any = {
    width: '400px',
    height: '700px',
    closable: true,
    header: 'Fiko Analiz Aracı'
  };

  @Input() parametreler: any = {};

  constructor(
    public readonly FikoYT: FikoYTService,
    public readonly CD: ChangeDetectorRef
  ) { }

  initComponent() {
    if (this.parametreler && this.parametreler.anaGosterim) {
      this.anaGosterim = this.parametreler.anaGosterim;
    }
    if (this.parametreler && this.parametreler.ayarlar) {
      this.ayarlar = { ...this.ayarlar, ...this.parametreler.ayarlar };
    }
  }

  public ac(anaGosterim?: FikoThreeJsComponent, ayarlar?: any) {
    if (anaGosterim) {
      this.anaGosterim = anaGosterim;
    }
    if (ayarlar) {
      this.ayarlar = { ...this.ayarlar, ...ayarlar };
    }

    var _this = this;

    // Modal sadece ilk seferde initialize edilir
    if (!this.modalBaslatildi) {
      $("#" + this.id_dialog).modal({
        closable: this.ayarlar.closable || false,
        allowMultiple: true,
        detachable: false, // Modal'ın DOM'da kalmasını sağla (yeniden açılabilmesi için kritik)
        keyboardShortcuts: false, // ESC tuşunu devre dışı bırak
        onShow: function () {
          $("#" + _this.id_dialog).parent().removeClass('dimmer');
          $("#" + _this.id_dialog).draggable({ handle: ".baslikMove" });
          $("#" + _this.id_dialog).parent().css('width', _this.ayarlar.width || '400px');
          $("#" + _this.id_dialog).parent().css('height', _this.ayarlar.height || '700px');
        }
      });
      this.modalBaslatildi = true;
    }

    $("#" + this.id_dialog).modal('show');

    this.analizTipi = 'DraftAngle';
    this.CD.detectChanges();
  }

  private temizle() {
    if (this.FikoYTDraftAngle) {
      this.FikoYTDraftAngle.bitir();
    }
    if (this.FikoYTUndercut) {
      this.FikoYTUndercut.bitir();
    }
    if (this.FikoYTWallThickness) {
      this.FikoYTWallThickness.bitir();
    }
  }

  public kapa() {
    this.subsList.forEach(element => {
      if (element && element.unsubscribe) {
        element.unsubscribe();
      }
    });

    this.haritaOlaylar.forEach((value: any, key: string) => {
      if (value && typeof value === 'function') {
        value();
      }
    });

    if (this.dialogCloseSub) {
      this.dialogCloseSub.unsubscribe();
      this.dialogCloseSub = null;
    }

    this.temizle();

    // Dialog core'ın kapa metodunu çağır
    if (this.pencere && typeof this.pencere.kapa === 'function') {
      try {
        this.pencere.kapa();
        return; // FikoDialogCore içindeyken kendi modal'ımızı kapatmaya çalışma
      } catch (error) {
        // Error handling
      }
    }

    // Sadece standalone modda (pencere yoksa) kendi modal'ımızı kapat
    try {
      $("#" + this.id_dialog).modal('hide');
    } catch (error) {
      // Error handling
    }
  }

  ngOnDestroy(): void {
    $("#" + this.id_dialog).remove();
    this.subsList.forEach(element => {
      if (element && element.unsubscribe) {
        element.unsubscribe();
      }
    });

    this.haritaOlaylar.forEach((value: any, key: string) => {
      if (value && typeof value === 'function') {
        value();
      }
    });

    if (this.dialogCloseSub) {
      this.dialogCloseSub.unsubscribe();
      this.dialogCloseSub = null;
    }

    if (this.FikoYTDraftAngle) {
      this.FikoYTDraftAngle.bitir();
    }
    if (this.FikoYTUndercut) {
      this.FikoYTUndercut.bitir();
    }
    if (this.FikoYTWallThickness) {
      this.FikoYTWallThickness.bitir();
    }

    this.anaGosterim = null;
    this.pencere = null;
  }
}
